import { all } from 'redux-saga/effects'
import API from '../services/Api'
import { BASEURL } from '../constants/urls'
import initStartUpSaga from './startup.saga'
import initDeviceSaga from '../device/device.saga.web'
import initAuthSaga from '../auth/index.saga'
import initLoginSaga from '../auth/Login/index.saga'
import initSignupSaga from '../auth/Signup/index.saga'
import initChangePasswordSaga from '../auth/ChangePassword/index.saga'
import initForgotPasswordSaga from '../auth/ForgotPassword/forgotPassword.saga'
import initAcceptInviteSaga from '../auth/InviteUser/acceptInvite.saga'
import initUsersSaga from '../users/index.saga'
import initPracticesSaga from '../organizations/index.saga'
import initPatientSaga from '../patient/patient.saga'
import initMessageSaga from '../message/message.saga'
import initNoteSaga from '../note/note.saga'
import initBillingSaga from '../billing/billing.saga.web'
import initTimeTrackingSaga from '../Timetracking/timetracking.saga'
import initCallLogsSaga from '../callLog/callLog.saga'
import initPatientVitalsSaga from '../vital/vital.saga'

const { create } = API
export const api = create(BASEURL)

export default function* root() {
  yield all([
    // Start Up
    ...initStartUpSaga(api),

    // Device
    ...initDeviceSaga(api),

    // Patient
    ...initPatientSaga(api),

    // Auth
    ...initAuthSaga(api),

    // Login
    ...initLoginSaga(api),

    // Change Password
    ...initChangePasswordSaga(api),

    // Forgot Password
    ...initForgotPasswordSaga(api),

    // Accept Invite
    ...initAcceptInviteSaga(api),

    // Signup
    ...initSignupSaga(api),

    // Users
    ...initUsersSaga(api),

    // Practices
    ...initPracticesSaga(api),

    // Messages
    ...initMessageSaga(api),

    // Notes
    ...initNoteSaga(api),
    // Billings

    ...initBillingSaga(api),

    // TimeTracking
    ...initTimeTrackingSaga(api),

    // CallLog
    ...initCallLogsSaga(api),

    // PatientVitals
    ...initPatientVitalsSaga(api)

  ])
}
